var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative flex-1 p-4 overflow-y-auto bg-gray-100 shadow-inner"},[(_vm.loading)?_c('PLoader'):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }